import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';

export const StyledPagination = styled('div')(
  () => css`
    .pagination {
      .MuiPagination-ul {
        li {
          .MuiButtonBase-root {
            font-family: inherit !important;
            color: #333;
            border: 1px solid transparent;
            max-width: 44px;

            &:hover {
              border: 1px solid #199da3;
              background-color: unset;
              border-radius: 8px;
            }

            &.Mui-selected {
              background: #199da3;
            }
          }
        }
      }
    }
  `
);
